import type { RouteLocationRaw } from 'vue-router'
import { ChannelFacility } from '../models/ChannelFacility'
import { Temporal } from '@js-temporal/polyfill'
import type { VBtnTo, VDataTableHeader } from './vuetify'

export interface ActionGroupAction {
  label: string
  icon?: string
  href?: string
  to?: RouteLocationRaw
  event?: string // TODO: really a string?
  disabled?: boolean
}

export interface DateRange {
  start: Temporal.PlainDate
  end: Temporal.PlainDate
}

export type UserSolutionType = 'blackouts' | 'reporting' | 'universalInventory' | 'rateManagement' | 'maxCapacity' | 'rateParity'
export type RateUnit = 'hour' | 'day'

export interface DefaultRateFieldState {
  readonly id: null | number
  defaultCost: null | number
}

export interface ChannelDefaultRateFieldState {
  readonly id: null | number
  channelCost: null | number
  readonly originalChannelCost: null | number
  readonly channelFacility: ChannelFacility
}

export interface DefaultRateFieldWithCdrsState extends DefaultRateFieldState {
  channelDefaultRates: ChannelDefaultRateFieldState[]
}

export interface DefaultRateFieldsWithCdrsState {
  defaultRates: DefaultRateFieldWithCdrsState[]
}

export enum Weekday {
  // ISO 8601
  Sun = 7,
  Mon = 1,
  Tue = 2,
  Wed = 3,
  Thu = 4,
  Fri = 5,
  Sat = 6,
}

export enum PythonWeekday {
  // Some backend endpoints expect these values instead. Always use the standard Weekday on the front end, and convert
  // for submission to the back end when needed.
  Sun = 0,
  Mon = 1,
  Tue = 2,
  Wed = 3,
  Thu = 4,
  Fri = 5,
  Sat = 6,
}

export interface ColumnPickerHeader extends VDataTableHeader {
  toggleable?: boolean // default true. If false, this column will be disabled in the picker.
  hidden?: boolean // default false. If true, this column will not be displayed in the picker.
  hideFromPicker?: boolean // default false
}

export interface TableToolsAction {
  // Include exactly one of the following keys: href, to, click
  title: string
  icon: string
  disabled?: boolean, // default false
  busy?: boolean, // default false
  href?: string // a URL to navigate to when the action is clicked
  to?: VBtnTo // a vue-router route to navigate to when the action is clicked
  click?: Function // a callback to invoke when the action is clicked
  hidden?: boolean // default false
}
